import { render, staticRenderFns } from "./musicMetaData.vue?vue&type=template&id=b1666d40&scoped=true"
import script from "./musicMetaData.vue?vue&type=script&lang=js"
export * from "./musicMetaData.vue?vue&type=script&lang=js"
import style0 from "./musicMetaData.vue?vue&type=style&index=0&id=b1666d40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1666d40",
  null
  
)

export default component.exports